@if (visibleContracts?.length) {
  <table class="table">
    <thead>
      <tr>
        <th>Rabatter</th>
        <th>Startdatum</th>
        <th>Slutdatum</th>
        <th>Byrå</th>
        <th>Skapad</th>
        @if (enableDelete && isAdminOrPlannerOrSales) {
          <th>Ta bort</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (contract of visibleContracts; track $index) {
        <tr
          class="with-seperator"
          [hidden]="contract.ended && !showEnded"
          [ngClass]="{'inactive': contract.ended}"
        >
          <td>
            @for (contractPart of contract.discounts; track $index) {
              <ul class="reset--list">
                @for (discount_type of contractPart.discount_types; track $index) {
                  <li>
                    <div class="tab tab--small">
                      {{translateDiscountType(discount_type)}} {{contractPart.discount_rate | percent: '1.0-2'}}
                    </div>
                  </li>
                }
              </ul>
            }
          </td>
          <td>{{contract.start_date | date:'yyyy-MM-dd'}}</td>
          <td>{{contract.end_date | date:'yyyy-MM-dd'}}</td>
          <td>{{contract.agency?.nickname || '-'}}</td>
          <td>{{contract.created_at | date:'yyyy-MM-dd'}}</td>
          @if (enableDelete && isAdminOrPlannerOrSales) {
            <td>
              <button class="text-danger" (click)="delete(contract)">
                <span class="icon-trash"></span>
              </button>
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
} @else {
  <p class="text--italic">
    Det finns inga upplagda.
  </p>
}
